'use client';

import React, { useState } from 'react';
import { animate } from 'framer-motion';
import commonStyles from '@/app/(website)/commonStyles.module.scss';
import styles from './articleTableOfContents.module.scss';
import { Heading } from '@/services/cmsFormatUtils';

type ArticleTableOfContentsProps = {
  readonly headings: Heading[];
};

const HEADER_OFFSET = 120;

const ArticleTableOfContents: React.FC<ArticleTableOfContentsProps> = ({
  headings
}) => {
  const [activeId, setActiveId] = useState<string>('');

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();

    const element = document.getElementById(id);
    if (!element) return;

    const targetPosition = element.offsetTop - HEADER_OFFSET;
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;

    animate(startPosition, startPosition + distance, {
      duration: 0.8,
      ease: [0.25, 0.1, 0.25, 1],
      onUpdate: (latest) => {
        window.scrollTo(0, latest);
        setActiveId(id);
      }
    });
  };

  return (
    <aside className={styles.tableOfContents}>
      <div className={styles.tableOfContentsCard}>
        <h3
          className={`${styles.tableOfContentsTitle} ${commonStyles.sectionSubheadingH5}`}
        >
          In this article
        </h3>
        <nav className={styles.tableOfContentsNav}>
          <ul className={styles.tableOfContentsList}>
            {headings.map((heading) => (
              <li key={heading.id} className={styles.tableOfContentsItem}>
                <a
                  href={`#${heading.id}`}
                  onClick={(e) => handleClick(e, heading.id)}
                  aria-label="content table scroll to section"
                  className={`${styles.tableOfContentsLink} ${commonStyles.sectionLink} ${
                    activeId === heading.id ? styles.active : ''
                  }`}
                >
                  {heading.text}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default ArticleTableOfContents;
